import React, { useEffect, useState, useCallback } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase"; // Importer l'authentification Firebase et Firestore
import { useNavigate } from "react-router-dom";
import '../componentsCSS/AdminPage.css' // Importer le CSS spécifique à ce composant
// import { UserContext } from '../UserContext';


function AdminPage() {
    const [pendingUsers, setPendingUsers] = useState([]);
    const [decisions, setDecisions] = useState({}); // Format { UID: "accepted" | "rejected" }
    const [isLoading, setIsLoading] = useState(true);
    const [isAdmin, setIsAdmin] = useState(false);
    const navigate = useNavigate();
    const [view, setView] = useState("pendingUsers"); // Valeurs possibles : "pendingUsers", "publicInfo", "privateInfo"
    const [publicInfo, setPublicInfo] = useState([]);
    const [privateInfo, setPrivateInfo] = useState([]);
    const [statsJour, setStatsJour] = useState([]);
    const tableHeaders = {
      pendingUsers: ["Index", "UID", "Pseudo", "Email", "Nom", "Prénom", "Entreprise", "Action"],
      publicInfo: ["Index", "UID", "Pseudo", "Points", "Streak", "Cases"],
      privateInfo: ["Index", "UID", "Nom", "Prénom", "Email", "Entreprise"],
      statsJour: ["Day", "Index", "Openers"],
    };
    const headerKeyMap = {
      UID: "uid",
      Pseudo: "pseudo",
      Email: "email",
      Nom: "nom",
      Prénom: "prenom",
      Entreprise: "entreprise",
      Points: "points",
      Réponses: "reponses", 
      Sreak: "streak",
      Cases: "cases_opened",
      Day: "day",
      Openers: "openers",
      // Ajoutez d'autres mappings si nécessaire
    };
    const renderRows = () => {
      if (view === "pendingUsers") {
          return pendingUsers.map((user, index) => (
              <tr key={user.uid}>
                  <td>{index + 1}</td>
                  <td>{user.uid}</td>
                  <td>{user.pseudo}</td>
                  <td>{user.email}</td>
                  <td>{user.nom}</td>
                  <td>{user.prenom}</td>
                  <td>{user.entreprise}</td>
                  <td>
                      <button 
                        className={getButtonClass(user.uid, "accepted")}
                        onClick={() => handleUserSelection(user.uid, "accepted")}>Accepter</button>
                      <button 
                        className={getButtonClass(user.uid, "rejected")}
                        onClick={() => handleUserSelection(user.uid, "rejected")}>Refuser</button>
                  </td>
              </tr>
          ));
      } else if (view === "publicInfo") {
        console.log("infos : ", publicInfo)
          return publicInfo.map((info, index) => (
              <tr key={info.uid}>
                  <td>{index + 1}</td>
                  <td>{info.uid}</td>
                  <td>{info.pseudo}</td>
                  <td>{info.points}</td>
                  <td>{info.streak}</td>
                  <td>{info.cases_opened}</td>
                  {/* <td>{info.quizz_answers.join(", ")}</td> */}
              </tr>
          ));
      } else if (view === "privateInfo") {
          return privateInfo.map((info, index) => (
              <tr key={info.uid}>
                  <td>{index + 1}</td>
                  <td>{info.uid}</td>
                  <td>{info.nom}</td>
                  <td>{info.prenom}</td>
                  <td>{info.email}</td>
                  <td>{info.entreprise}</td>
              </tr>
          ));
      } else if (view === "statsJour") {
        // Transformer statsJour en un tableau d'entrées avec le jour, un index et l'UID
        const rows = [];
        statsJour.forEach((info, dayIndex) => {
            info.openers.forEach((opener, openerIndex) => {
                rows.push({ day: dayIndex + 1, count: openerIndex + 1, uid: opener });
            });
        });
    
        // Rendre les lignes du tableau
        return rows.map((row, index) => (
            <tr key={`${row.day}-${row.count}`}>
                <td>{row.day}</td>
                <td>{row.count}</td>
                <td>{row.uid}</td>
            </tr>
        ));
    }
    };
    const refreshView = () => {
      if (view === "pendingUsers") {
          fetchPendingUsers();
      } else if (view === "publicInfo") {
          fetchPublicInfo();
      } else if (view === "privateInfo") {
          fetchPrivateInfo();
      } else if (view === "statsJour") {
        fetchStatsJour();
    }
    };
  
  
    // Vérifie le rôle de l'utilisateur
    useEffect(() => {
      // const auth = getAuth();
  
      // Écoute l'état d'authentification
      const unsubscribe = onAuthStateChanged(auth, async (user) => {
        if (user) {
          try {
            // Vérifie les claims du token
            const idTokenResult = await user.getIdTokenResult();
            if (idTokenResult.claims.role === "admin") {
              setIsAdmin(true); // Autorise l'accès
              console.log("admin connecté")
            } else {
              // navigate("/"); // Redirige si non admin
            }
          } catch (error) {
            console.error("Erreur lors de la vérification du rôle :", error);
            // navigate("/"); // Redirige en cas d'erreur
          }
        } else {
          // Redirige si l'utilisateur n'est pas connecté
          console.log('pas connecté')
          // navigate("/");
        }
        setIsLoading(false); // Fin du chargement
      });
  
      return () => unsubscribe(); // Nettoie l'écouteur lors du démontage
    }, [navigate]);
  
    // Charge les utilisateurs en attente
  const fetchAdminData = useCallback(async (endpoint) => {
    // const auth = getAuth();
    const idToken = await auth.currentUser.getIdToken();
    const response = await fetch(`https://api-secret-forsides.forsides-group.com${endpoint}`, {
    // const response = await fetch(`http://127.0.0.1:5000${endpoint}`, {
      method: "GET",
      headers: { Authorization: `Bearer ${idToken}` },
    });
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      const error = await response.json();
      throw new Error(error.error || "Erreur inconnue");
    }
  }, []);
  
  
    // Sélectionne un utilisateur comme accepté ou refusé
    const handleUserSelection = (uid, decision) => {
      setDecisions((prevDecisions) => {
        const newDecisions = {
          ...prevDecisions,
          [uid]: decision,
        };
        return newDecisions;
      });
  };

  const getButtonClass = (uid, decision) => {
    if (decisions[uid] === "accepted" && decision === "accepted") {
        return "accepted";
    }
    if (decisions[uid] === "rejected" && decision === "rejected") {
        return "rejected";
    }
    return "";
};

  const fetchPendingUsers = useCallback(async () => {
    setIsLoading(true);
    try {
      const data = await fetchAdminData("/api/admin/pending-users");
      setPendingUsers(
        Object.entries(data?.pending_users?.users || {}).map(([uid, userInfo]) => ({
          uid,
          ...userInfo,
        }))
      );
    } catch (error) {
      console.error("Erreur lors du chargement des Pending Users :", error);
      alert("Erreur lors du chargement des Pending Users.");
    } finally {
      setIsLoading(false);
    }
  }, [fetchAdminData]); 

  const fetchPublicInfo = useCallback(async () => {
    setIsLoading(true);
    try {
      const data = await fetchAdminData("/api/admin/public-info");
      setPublicInfo(
        Object.entries(data?.public_info?.users || {}).map(([uid, userInfo]) => ({
          uid,
          ...userInfo,
        }))
      );
    } catch (error) {
      console.error("Erreur lors du chargement des Pending Users :", error);
      alert("Erreur lors du chargement des Pending Users.");
    } finally {
      setIsLoading(false);
    }
  }, [fetchAdminData]); 

  const fetchPrivateInfo = useCallback(async () => {
    setIsLoading(true);
    try {
      const data = await fetchAdminData("/api/admin/private-info");
      setPrivateInfo(
        Object.entries(data?.private_info?.users || {}).map(([uid, userInfo]) => ({
          uid,
          ...userInfo,
        }))
      );
    } catch (error) {
      console.error("Erreur lors du chargement des Pending Users :", error);
      alert("Erreur lors du chargement des Pending Users.");
    } finally {
      setIsLoading(false);
    }
  }, [fetchAdminData]); 

  const fetchStatsJour = useCallback(async () => {
    setIsLoading(true);
    try {
      const data = await fetchAdminData("/api/admin/public-info");
      setStatsJour(
        Object.entries(data?.public_info?.statsJour || {}).map(([day, userList]) => ({
          day,
          ...userList,
        }))
      );
    } catch (error) {
      console.error("Erreur lors du chargement des stats jour :", error);
      alert("Erreur lors du chargement des stats jour.");
    } finally {
      setIsLoading(false);
    }
  }, [fetchAdminData]); 


  // const fetchData = useCallback(async (endpoint, setState) => {
  //   setIsLoading(true);
  //   try {
  //     // const data = await fetchAdminData(endpoint);
  //     const data = await fetchAdminData("/api/admin/private-info");
  //     setState(
  //       Object.entries(data?.p_data?.users || {}).map(([uid, userInfo]) => ({
  //         uid,
  //         ...userInfo,
  //       }))
  //     );
  //   } catch (error) {
  //     console.error("Erreur lors du chargement des données :", error);
  //     alert("Erreur lors du chargement des données.");
  //   } finally {
  //     setIsLoading(false);
  //   }
  // }, [fetchAdminData]);

  useEffect(() => {
    if (isAdmin) {
      if (view === "pendingUsers") {
        fetchPendingUsers();
      } else if (view === "publicInfo") {
        fetchPublicInfo();
      } else if (view === "privateInfo") {
        fetchPrivateInfo();
      } else if (view === "statsJour") {
        fetchStatsJour();
      }
    }
  }, [view, fetchPendingUsers, fetchPublicInfo, fetchPrivateInfo, fetchStatsJour, isAdmin]);

    // Valide ou refuse les utilisateurs sélectionnés
    const handleConfirm = async () => {
      try {
          // const auth = getAuth();
          const idToken = await auth.currentUser.getIdToken();
          const response = await fetch(`https://api-secret-forsides.forsides-group.com/api/admin/confirm-decisions`, {
          // const response = await fetch("http://127.0.0.1:5000/api/admin/confirm-decisions", {
              method: "POST",
              headers: {
                  Authorization: `Bearer ${idToken}`,
                  "Content-Type": "application/json",
              },
              body: JSON.stringify({ decisions }),
          });
  
          if (response.ok) {
              const data = await response.json();
              console.log("Décisions confirmées :", data);
              alert("Décisions confirmées avec succès !");
              setDecisions({}); // Réinitialise les décisions
              fetchPendingUsers(); // Recharge la liste des PendingUsers
          } else {
              const error = await response.json();
              console.error("Erreur :", error);
              alert(error.error || "Erreur lors de la confirmation des décisions.");
          }
      } catch (error) {
          console.error("Erreur :", error);
          alert("Erreur inattendue lors de la confirmation.");
      }
  };  

  const downloadCSV = () => {
    let data = [];
    let headers = [];
    let filename = "";
  
    if (view === "pendingUsers") {
      data = pendingUsers;
      headers = tableHeaders.pendingUsers.filter((header) => header !== "Action"); // Exclure la colonne 'Action'
      filename = "pending_users.csv";
    } else if (view === "publicInfo") {
      data = publicInfo;
      headers = tableHeaders.publicInfo;
      filename = "public_info.csv";
    } else if (view === "privateInfo") {
      data = privateInfo;
      headers = tableHeaders.privateInfo;
      filename = "private_info.csv";
    } else if (view === "statsJour") {
      data = statsJour;
      headers = tableHeaders.statsJour;
      filename = "statsJour.csv";
    }
  
    // Convertir les données en format CSV
    const csvRows = [];
  
    // Ajouter les en-têtes
    csvRows.push(headers.join(","));
  
    // Ajouter les lignes de données
    data.forEach((item) => {
      const row = headers.map((header) => {
        const key = headerKeyMap[header] || header.toLowerCase();
        let value = item[key] || "";
        if (Array.isArray(value)) {
          value = value.join(", "); // Gérer les tableaux
        }
        // Échapper les guillemets dans la valeur
        value = value.toString().replace(/"/g, '""');
        return `"${value}"`; // Envelopper chaque champ entre guillemets
      });
      csvRows.push(row.join(","));
    });
  
    const csvContent = "\uFEFF" + csvRows.join("\n"); // Ajouter le BOM pour la compatibilité avec Excel
  
    // Créer un Blob à partir du contenu CSV
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  
    // Créer un lien pour télécharger le Blob
    const link = document.createElement("a");
    if (link.download !== undefined) {
      // Navigateurs qui supportent l'attribut download
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", filename);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };
  

  if (isLoading) {
    return (
      <div className="wrapper">
        <div>Chargement...</div>
      </div>
    );
  }

    if (!isAdmin) {
      return null; // Empêche l'affichage du tableau de bord si non admin
    }
  
    // if (view === "pendingUsers" && pendingUsers.length === 0) {
    //   return (
    //     <div className="wrapper">
    //       <p>Aucun utilisateur en attente.</p>
    //     </div>
    //   );
    // }
  
    return (
      <div className="wrapper-admin">
        <div>
          <h1>Page Admin</h1>
          <button onClick={refreshView}>Actualiser</button> {/* Bouton Actualiser */}
          <button onClick={downloadCSV}>Télécharger CSV</button>
          <div>
              <button onClick={() => setView("pendingUsers")}>Pending Users</button>
              <button onClick={() => setView("publicInfo")}>Public Info</button>
              <button onClick={() => setView("privateInfo")}>Private Info</button>
              <button onClick={() => setView("statsJour")}>Stats Jour</button>
          </div>

          { (view === "pendingUsers" && pendingUsers.length === 0) && (
            <p>Aucun utilisateur en attente.</p>
          )}

          <table>
          <thead>
              <tr>
                  {tableHeaders[view].map((header) => (
                      <th key={header}>{header}</th>
                  ))}
              </tr>
          </thead>
          <tbody>{renderRows()}</tbody>
          </table>

          <button onClick={handleConfirm}>Confirmer</button>
        </div>
      </div>
    );
  }
  
  export default AdminPage;
  